module.exports = __webpack_public_path__ + "static/media/EXC_ACE_RGB_PS.ec2d404f.svg";